import { ProgressBar, Skeleton } from '@round/ui-kit';
import styles from './BudgetCell.module.css';
import { asMoneyWithoutZeros } from 'helpers';
import { toDecimalPoint } from '@round/utils';
import { getApplicationStyleVariables } from '@round/whitelabel-ui';
import cn from 'classnames';
import { useCurrencies } from 'contexts/OptionsContext/useCurrencies';
import { applicationManager } from '@round/api';

export type Props = {
    cost: number | null;
    currencyId: number | null;
    amountSpent: number | null;
    spentPercentage: number | null;
    managedBy: applicationManager.Application;
    isPostCostEditable: boolean;
    isLoading: boolean;
};

const BudgetCell = ({
    cost,
    currencyId,
    amountSpent,
    spentPercentage,
    managedBy,
    isPostCostEditable,
    isLoading,
}: Props) => {
    const { getCurrencyById } = useCurrencies();

    if (isLoading) {
        return <Skeleton />;
    }

    const currency = getCurrencyById(currencyId);

    const formattedSpentPercentage =
        typeof spentPercentage === 'number' ? ` ${toDecimalPoint(spentPercentage, 2)}%` : '-';

    return (
        <div className={styles.container}>
            {isPostCostEditable && spentPercentage !== 100 ? (
                <>
                    <span className={styles.primaryAmount}>{asMoneyWithoutZeros(cost, currency)}</span>
                    <div className={cn(styles.amountRow, styles.secondaryAmount)}>
                        <span>{asMoneyWithoutZeros(amountSpent, currency)}</span>
                        <span>{formattedSpentPercentage}</span>
                    </div>
                </>
            ) : (
                <div className={styles.amountRow}>
                    <span className={styles.primaryAmount}>{asMoneyWithoutZeros(cost, currency)}</span>
                    <span className={styles.secondaryAmount}>{formattedSpentPercentage}</span>
                </div>
            )}
            {typeof spentPercentage === 'number' && (
                <ProgressBar
                    progress={spentPercentage}
                    trackClassName={styles.spentTrack}
                    barClassName={cn(styles.spentBar, getApplicationStyleVariables(managedBy))}
                />
            )}
        </div>
    );
};

export default BudgetCell;
